// theme.ts
import { ETree } from '@NGUtils/enums';
import { DefaultTheme } from 'styled-components';

export const defaultTheme = {
	radius: {
		s: '3px',
		m: '5px',
		l: '7px'
	},
	spacing: {
		unset: 'unset',
		'6xs': '2px',
		'5xs': '4px',
		'4xs': '8px',
		'3xs': '12px',
		'2xs': '16px',
		xs: '20px',
		s: '24px',
		m: '32px',
		l: '40px',
		xl: '48px',
		'2xl': '64px',
		'3xl': '80px',
		'4xl': '100px',
		'5xl': '120px',
		'6xl': '140px',
		'7xl': '160px',
		'8xl': '180px'
	}
};

const treesColors = {
	[ETree.solidity]: {
		default: '#65AFFF',
		borderColor: '#98A7F5',
		logoGradient: 'radial-gradient(55.23% 46.02% at 50% 50%, #5F9FE2 41.96%, #45709D 100%);',
		backgroundGradient: 'linear-gradient(316.11deg, #65AFFF1A 14.38%, #60AEB91A 85.52%);',
		hoverBackgroundGradient:
			'linear-gradient(316.11deg, rgba(101, 175, 255, 0.1) 14.38%, rgba(96, 174, 185, 0.1) 85.52%)',
		hoverColor: '#3859ff',
		treeBackground: '#0066FF2E'
	},
	[ETree.noir]: {
		default: '#65AFFF',
		borderColor: '#98A7F5',
		logoGradient: 'radial-gradient(55.23% 46.02% at 50% 50%, #5F9FE2 41.96%, #45709D 100%);',
		backgroundGradient: 'linear-gradient(316.11deg, #65AFFF1A 14.38%, #60AEB91A 85.52%);',
		hoverBackgroundGradient:
			'linear-gradient(316.11deg, rgba(101, 175, 255, 0.1) 14.38%, rgba(96, 174, 185, 0.1) 85.52%)',
		hoverColor: '#3859ff',
		treeBackground: '#0066FF2E'
	},
	[ETree.general]: {
		default: '#9F8C6C',
		borderColor: '#846000',
		logoGradient: 'radial-gradient(82.76% 82.76% at 52.71% 6.05%, #76552F 14.65%, #9F8C6C 100%);',
		backgroundGradient: 'linear-gradient(316.11deg, rgba(123, 44, 0, 0.1) 14.38%, rgba(168, 138, 31, 0.1) 85.52%);',
		hoverBackgroundGradient: 'linear-gradient(316.11deg, #966f0610 14.38%, #84600010 85.52%)',
		hoverColor: '#966f06',
		treeBackground: '#FFA8001A'
	},
	// need to be updated with the right colors
	[ETree.cairo]: {
		default: '#FE4A3C',
		borderColor: '#FE4A3C',
		logoGradient: 'radial-gradient(82.76% 82.76% at 52.71% 6.05%, #FE4A3C 14.65%, #FE4A3C 100%);',
		backgroundGradient: 'linear-gradient(316.11deg, rgba(123, 44, 0, 0.1) 14.38%, rgba(168, 138, 31, 0.1) 85.52%);',
		hoverBackgroundGradient: 'linear-gradient(316.11deg, #FE4A3C10 14.38%, #84600010 85.52%)',
		hoverColor: '#FE4A3C',
		treeBackground: '#FE4A3C1A'
	},
	unset: {
		default: '#65AFFF',
		borderColor: '#98A7F5',
		logoGradient: 'linear-gradient(180deg, #65AFFF 4.17%, #6C6CBE 100%);',
		backgroundGradient: 'linear-gradient(316.11deg, #65AFFF1A 14.38%, #60AEB91A 85.52%);',
		hoverBackgroundGradient:
			'linear-gradient(316.11deg, rgba(101, 175, 255, 0.1) 14.38%, rgba(96, 174, 185, 0.1) 85.52%)',
		hoverColor: '#3859ff',
		treeBackground: '#0066FF2E'
	}
};

export const darkTheme: DefaultTheme = {
	...defaultTheme,
	colors: {
		gold: '#9F8C6C',
		darkGold: '#66573F',
		white: '#F1F2F2',
		grey: '#8E8E8E',
		ash: '#525252',
		lead: '#333030',
		carbon: '#1D1C1A',
		charcoal: '#151515',
		black: '#0F0F0F',
		dark: '#1B1713',
		success: '#4D8A42',
		error: '#B91616',
		information: '#425CC2',
		transparentGold: '#9F8C6C50',
		transparentBlack: '#15151575',
		orange: '#D55F2C',
		text: {
			gold: '#9F8C6C',
			darkGold: '#9F8C6C',
			white: '#F1F2F2',
			grey: '#8E8E8E',
			black: '#0F0F0F',
			success: '#4D8A42',
			error: '#B91616',
			transparentGold: '#9F8C6C50',
			[ETree.solidity]: treesColors[ETree.solidity].default,
			[ETree.general]: treesColors[ETree.general].default,
			[ETree.cairo]: treesColors[ETree.cairo].default
		},
		tree: treesColors,
		rarity: {
			common: '#FFFFFF',
			uncommon: '#1EFF00',
			rare: '#0070DD',
			epic: '#A335EE',
			legendary: '#FF8000',
			unique: '#D2AB68'
		}
	}
};

export const lightTheme: DefaultTheme = darkTheme;
